function requireAll(r) {
  r.keys().forEach(r);
}

export default requireAll;
